'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactBootstrap = require('react-bootstrap');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _dateFunctions = require('../../helpers/dateFunctions');

var _dateFunctions2 = _interopRequireDefault(_dateFunctions);

var _LabelledInputComponent = require('../../components/input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _RadioGroupComponent = require('../../components/input/RadioGroupComponent');

var _RadioGroupComponent2 = _interopRequireDefault(_RadioGroupComponent);

var _SectionHeaderComponent = require('../../components/common/SectionHeaderComponent');

var _SectionHeaderComponent2 = _interopRequireDefault(_SectionHeaderComponent);

var _formConfiguration = require('../../transformers/common/formConfiguration');

var _formConfiguration2 = _interopRequireDefault(_formConfiguration);

var _application = require('../../transformers/rimi_vtc/application');

var _application2 = _interopRequireDefault(_application);

var _Quote = require('../../validators/rimi_vtc/Quote');

var _Quote2 = _interopRequireDefault(_Quote);

var _translate = require('../../language/translate');

var _InitialValues = require('../common/InitialValues');

var _InitialValues2 = _interopRequireDefault(_InitialValues);

var _commonFunctions = require('../../helpers/commonFunctions');

var _quote = require('../../transformers/rimi_vtc/quote');

var _quote2 = _interopRequireDefault(_quote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable prefer-arrow-callback */

var fields = [].concat(_toConsumableArray((0, _commonFunctions.getBaseFields)()), _toConsumableArray((0, _commonFunctions.getApplicantDetailFields)()), ['applicant[].additional_data.mq.mq1', 'applicant[].additional_data.mq.mq2', 'applicant[].additional_data.mq.mq3', 'applicant[].additional_data.mq.mq4', 'applicant[].additional_data.mq.mq5', 'applicant[].additional_data.mq.mq6', 'applicant[].additional_data.mq.mq7', 'applicant[].additional_data.mq.mq8', 'applicant[].additional_data.mq.mq9', 'applicant[].additional_data.mq.mq10', 'applicant[].additional_data.mq.mq11', 'applicant[].additional_data.pe_coverage', 'application.additional_data.policy_type', 'application.additional_data.destination_province', 'application.additional_data.tracking_code', 'application.additional_data.country_of_origin', 'application.additional_data.in_canada', 'application.additional_data.super_visa', 'application.additional_data.coverage', 'application.additional_data.deductible']);

var medQuestionsOld = [{
  key: 'mq1',
  text: (0, _translate.t)('1. Was your most recent heart bypass, heart angioplasty (including stent placement) or heart valve surgery more than 10 years prior to your effective date?')
}, {
  key: 'mq2',
  text: (0, _translate.t)('2. Have you been diagnosed with a heart condition as well as diabetes and/or hypertension (high blood pressure)?')
}, {
  key: 'mq3',
  text: (0, _translate.t)('3. Have you ever had or are you awaiting a bone marrow or organ transplant?')
}, {
  text: (0, _translate.t)('4. In the 24 months prior to your effective date have you been diagnosed with or treated for:')
}, {
  key: 'mq4',
  text: (0, _translate.t)('a) congestive heart failure?'),
  tabbed: true
}, {
  key: 'mq5',
  text: (0, _translate.t)('b) a lung condition with prednisone (or other oral steroid medication) or home oxygen?'),
  tabbed: true
}, {
  key: 'mq6',
  text: (0, _translate.t)('c) kidney or liver failure?'),
  tabbed: true
}, {
  key: 'mq7',
  text: (0, _translate.t)('d) peripheral vascular disease?'),
  tabbed: true
}, {
  text: (0, _translate.t)('5. In the 12 months prior to your effective date have you been diagnosed with or been treated for:')
}, {
  key: 'mq8',
  text: (0, _translate.t)('a) angina, chest pain or a heart attack?'),
  tabbed: true
}, {
  key: 'mq9',
  text: (0, _translate.t)('b) stroke, transient ischemic attack (TIA) or mini-stroke?'),
  tabbed: true
}, {
  key: 'mq10',
  text: (0, _translate.t)('c) cancer (excluding basal or squamous cell skin cancer or breast cancer treated only with hormone therapy)?'),
  tabbed: true
}, {
  key: 'mq11',
  text: (0, _translate.t)('d) internal bleeding?'),
  tabbed: true
}];

var medQuestions = [{
  key: 'mq1',
  text: (0, _translate.t)('1. Was your most recent heart bypass, heart angioplasty (including stent placement) or heart valve surgery more than 10 years prior to your effective date?')
}, {
  key: 'mq2',
  text: (0, _translate.t)('2. Have you been diagnosed with a heart condition as well as diabetes and/or hypertension (high blood pressure)? Answer NO if you have only diabetes/hypertension and do not have a heart condition.'),
  hint: 'Heart Disease or Condition is any Angioplasty or Stenting in or around the heart (coronary or carotid arteries or aorta), Angina, Atrial Fibrillation, Heart Failure (with reduced or preserved ejection fraction), Heart Attack/Myocardial Infarction, Irregular Heartbeat or Heart Murmur due to valvular pathology, Pacemaker/Defibrillator insertion, any Cardiovascular, Valve or Bypass surgery or any other condition or diagnosis relating to the Heart or Blood Vessels of the Heart.',
  hintTitle: ''
}, {
  key: 'mq3',
  text: (0, _translate.t)('3. Have you ever had or are you awaiting a bone marrow or organ transplant?')
}, {
  text: (0, _translate.t)('4. In the 24 months prior to your effective date have you been diagnosed with or treated for:')
}, {
  key: 'mq4',
  text: (0, _translate.t)('a) congestive heart failure?'),
  tabbed: true
}, {
  key: 'mq5',
  text: (0, _translate.t)('b) a lung condition with prednisone or other oral steroid medication (not including puffer) or home oxygen?'),
  tabbed: true
}, {
  key: 'mq6',
  text: (0, _translate.t)('c) kidney or liver failure?'),
  tabbed: true
}, {
  key: 'mq7',
  text: (0, _translate.t)('d) peripheral vascular disease?'),
  tabbed: true
}, {
  text: (0, _translate.t)('5. In the 12 months prior to your effective date have you been diagnosed with or been treated for:')
}, {
  key: 'mq8',
  text: (0, _translate.t)('a) angina, chest pain or a heart attack?'),
  tabbed: true
}, {
  key: 'mq9',
  text: (0, _translate.t)('b) stroke, transient ischemic attack (TIA) or mini-stroke?'),
  tabbed: true
}, {
  key: 'mq10',
  text: (0, _translate.t)('c) cancer (excluding basal or squamous cell skin cancer or breast cancer treated only with hormone therapy)?'),
  tabbed: true
}, {
  key: 'mq11',
  text: (0, _translate.t)('d) internal bleeding?'),
  tabbed: true
}];

var GetQuoteComponent = function (_React$Component) {
  _inherits(GetQuoteComponent, _React$Component);

  function GetQuoteComponent(props) {
    _classCallCheck(this, GetQuoteComponent);

    var _this = _possibleConstructorReturn(this, (GetQuoteComponent.__proto__ || Object.getPrototypeOf(GetQuoteComponent)).call(this, props));

    _this.onChangeHook = _this.onChangeHook.bind(_this);

    _this.showMQModal = _this.showMQModal.bind(_this);
    _this.hideMQModal = _this.hideMQModal.bind(_this);

    _this.shouldShowMQLink = _this.shouldShowMQLink.bind(_this);
    _this.getApplicantsWithMQ = _this.getApplicantsWithMQ.bind(_this);
    _this.recurringPaymentsAllowed = _this.recurringPaymentsAllowed.bind(_this);
    _this.getCoverageOptions = _this.getCoverageOptions.bind(_this);
    _this.disableExpiryDate = _this.disableExpiryDate.bind(_this);
    _this.getExpiryDate = _this.getExpiryDate.bind(_this);
    _this.disabledExpiryDate = true;
    _this.hasSuperVisa = true;
    _this.hasDefaultExpiry = true;

    _this.ageLimits = {
      maxYears: 90
    };

    _this.state = {
      showNames: true,
      formFilled: false,
      showSaveQuote: true,
      showErrors: false,
      showMQModal: false
    };
    return _this;
  }

  _createClass(GetQuoteComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.formConfig = (0, _formConfiguration2.default)(this.props.formConfig)[0].fields;
      if (this.props.fields.application.additional_data.additional_applicants_number.value === '') {
        this.props.fields.application.additional_data.additional_applicants_number.onChange(_InitialValues2.default.additional_applicants_number);
      }
      if (this.props.fields.applicant.length === 0) {
        this.props.fields.applicant.addField();
      }
    }
  }, {
    key: 'onChangeHook',
    value: function onChangeHook() {
      (0, _commonFunctions.updateQuote)(this, _application2.default);
    }
  }, {
    key: 'getApplicantsWithMQ',
    value: function getApplicantsWithMQ() {
      var _this2 = this;

      return this.props.fields.applicant.filter(function (el) {
        return el.additional_data.pe_coverage.value === 'yes';
      }).filter(function (el) {
        return (0, _moment2.default)(_this2.props.fields.application.effective_date.value).diff((0, _moment2.default)(el.dob.value), 'years') >= 70;
      });
    }
  }, {
    key: 'getCoverageOptions',
    value: function getCoverageOptions(defaultCoverageOptions) {
      return this.hasSuperVisa && (0, _commonFunctions.checkSuperVisa)(this) ? this.formConfig['additional_data.coverage_supervisa'].options : defaultCoverageOptions;
    }
  }, {
    key: 'getDefaultExpiryDate',
    value: function getDefaultExpiryDate() {
      var effDate = this.props.fields.application.effective_date.value;
      return effDate ? (0, _moment2.default)(effDate).add(364 + _dateFunctions2.default.getLeapYearDay(effDate, 364), 'days') : null;
    }
  }, {
    key: 'getExpiryDate',
    value: function getExpiryDate() {
      return (0, _commonFunctions.checkSuperVisa)(this) ? this.getDefaultExpiryDate() : null;
    }
  }, {
    key: 'disableExpiryDate',
    value: function disableExpiryDate() {
      return (0, _commonFunctions.checkSuperVisa)(this);
    }
  }, {
    key: 'recurringPaymentsAllowed',
    value: function recurringPaymentsAllowed() {
      if ((0, _commonFunctions.checkSuperVisa)(this, 'yes') || this.props.fields.application.additional_data.coverage.value >= 100000 && (0, _moment2.default)(this.props.fields.application.expiry_date.value).diff((0, _moment2.default)(this.props.fields.application.effective_date.value), 'days') === 364 + _dateFunctions2.default.getLeapYearDay(this.props.fields.application.effective_date.value, 364)) {
        return true;
      }

      if (this.props.fields.payment.payment_option.value === 'monthly') {
        this.updateProp('payment.payment_option', 'lumpsum');
      }

      return false;
    }
  }, {
    key: 'shouldShowMQLink',
    value: function shouldShowMQLink() {
      var minAge = 70;
      var maxAge = 85;
      var mQCount = 0;

      var allApplicants = this.props.fields.applicant.filter(function (el) {
        return el.additional_data.pe_coverage.value === 'yes';
      });

      var effDate = this.props.fields.application.effective_date.value;

      if (!effDate) {
        return false;
      }

      for (var i = 0; i < allApplicants.length; i++) {
        if (!allApplicants[i].first_name.value || allApplicants[i].first_name.value === '') {
          return false;
        }

        if (!allApplicants[i].last_name.value || allApplicants[i].last_name.value === '') {
          return false;
        }

        var applicantAgeOnEffDate = (0, _moment2.default)(effDate).diff(allApplicants[i].dob.value, 'years');

        if (applicantAgeOnEffDate >= minAge && applicantAgeOnEffDate < maxAge) {
          mQCount++;
        } else if (applicantAgeOnEffDate >= maxAge) {
          return false;
        }
      }

      return mQCount > 0 && mQCount < 3;
    }
  }, {
    key: 'showMQModal',
    value: function showMQModal() {
      this.setState({ showMQModal: true });
    }
  }, {
    key: 'hideMQModal',
    value: function hideMQModal() {
      this.setState({ showMQModal: false });
      this.onChangeHook();
    }
  }, {
    key: 'updateProp',
    value: function updateProp(propName, value) {
      this.props.dispatch((0, _reduxForm.change)('genericis', propName, value));
    }
  }, {
    key: 'render',
    value: function render() {
      (0, _quote2.default)(this);
      var dateRestrictions = _dateFunctions2.default.getDateLimits(this.props.values, this.ageLimits);
      var oldMQRequired = this.props.fields.application.created_at && (0, _moment2.default)(this.props.fields.application.created_at.value).isBefore((0, _moment2.default)('2023-09-19'));

      if (oldMQRequired) {
        this.formConfig['additional_data.eligibility'].hint = this.formConfig['additional_data.eligibility'].hintOld;
        medQuestions = medQuestionsOld;
      }

      var applicantsWithMQ = this.getApplicantsWithMQ();

      return _react2.default.createElement(
        _reactBootstrap.Form,
        { horizontal: true, onSubmit: this.props.handleSubmit },
        (0, _commonFunctions.showErrorDiv)(this),
        (0, _commonFunctions.showPrimaryApplicantInfo)(this, dateRestrictions),
        (0, _commonFunctions.createAdditionalApplicantRows)(this, dateRestrictions),
        this.shouldShowMQLink() && !this.props.hideMQ ? _react2.default.createElement(
          _reactBootstrap.Alert,
          { className: 'ingle-form-quote quote-box div-center' },
          _react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  (0, _translate.t)('A Medical Declaration must be completed if you are between 70 and 84 years of age as of the effective date of coverage and are applying to purchase coverage for stable pre-existing conditions that have been stable in the 180 days prior to your effective date')
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    {
                      bsStyle: 'primary',
                      className: 'ingle-form-submit-button button',
                      onClick: this.showMQModal
                    },
                    (0, _translate.t)('Open Medical Questionnaire')
                  )
                )
              )
            )
          )
        ) : null,
        (0, _commonFunctions.showEligibilityBox)(this),
        (0, _commonFunctions.showCountryOfOrigin)(this),
        (0, _commonFunctions.showInCanadaHint)(this),
        (0, _commonFunctions.showSuperVisa)(this),
        this.props.hasDestinationProvice ? (0, _commonFunctions.showDestinationProvince)(this) : null,
        (0, _commonFunctions.effectiveDateField)(this, dateRestrictions),
        (0, _commonFunctions.expiryDateField)(this, dateRestrictions),
        (0, _commonFunctions.showCoverageLength)(this),
        this.props.hasPolicyType ? (0, _commonFunctions.policyTypeField)(this) : null,
        (0, _commonFunctions.applicationCoverageOptions)(this),
        (0, _commonFunctions.showDeductible)(this, 80),
        (0, _commonFunctions.showSaveQuoteComponent)(this, _application2.default),
        this.state.showMQModal ? _react2.default.createElement(
          _reactBootstrap.Modal,
          { show: this.state.showMQModal, className: 'mqModal' },
          _react2.default.createElement(
            'div',
            { className: 'modal-button' },
            _react2.default.createElement(
              'div',
              { className: 'center-align' },
              _react2.default.createElement(
                'h3',
                null,
                (0, _translate.t)('MEDICAL DECLARATION')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'center-align' },
              (0, _translate.t)('This Medical Declaration must be completed if you are between 70 and 84 years of age as of the effective date of coverage and are applying to purchase coverage for pre-existing medical conditions that have been stable in the 180 days prior to your effective date. Coverage for any pre-existing medical conditions is not available if you are over 84 years of age.')
            ),
            _react2.default.createElement(
              _reactBootstrap.Grid,
              { fluid: true },
              _react2.default.createElement(
                _reactBootstrap.Row,
                { className: 'applicant-names' },
                _react2.default.createElement(_reactBootstrap.Col, { sm: 8 }),
                applicantsWithMQ.map(function (applicant, index) {
                  return _react2.default.createElement(
                    _reactBootstrap.Col,
                    { sm: 2, className: 'center-align' },
                    applicant.first_name.value,
                    ' ',
                    applicant.last_name.value
                  );
                }, this)
              ),
              medQuestions.map(function (question, index) {
                var hideLabel = null;
                var inputLabel = null;
                var mqRadio = 0;
                var tabbedHint = question.tabbed || question.hint;
                var questionHint = question.hint ? (0, _translate.t)(question.hint) : '';

                return _react2.default.createElement(
                  _reactBootstrap.Row,
                  null,
                  tabbedHint ? null : _react2.default.createElement(
                    _reactBootstrap.Col,
                    { sm: 8 },
                    (0, _translate.t)(question.text)
                  ),
                  question.key && applicantsWithMQ.map(function (applicant, applicantIndex) {
                    hideLabel = hideLabel === null ? !tabbedHint : true;
                    inputLabel = inputLabel === null ? question.text : '';

                    if (applicantsWithMQ.length > 1) {
                      mqRadio++;
                    }

                    return _react2.default.createElement(
                      _reactBootstrap.Col,
                      { sm: hideLabel ? 2 : applicantsWithMQ.length > 1 ? 10 : 14, className: 'center-align' },
                      _react2.default.createElement(_LabelledInputComponent2.default, {
                        hasExpandableHint: question.hint,
                        expandableHintId: 'mqHint' + question.key,
                        expandableHintTitle: question.hintTitle,
                        expandableHintContent: questionHint,
                        expandableHintIsRawHtml: true,
                        inputId: 'additionalApplicantPeCoverage',
                        inputLabel: inputLabel,
                        inputComponent: _RadioGroupComponent2.default,
                        inputComponentField: applicant.additional_data.mq[question.key],
                        inputComponentProps: {
                          options: [{ value: '1', text: 'Yes' }, { value: '0', text: 'No' }]
                        },
                        hideLabel: hideLabel,
                        mqRadio: mqRadio
                      })
                    );
                  }, this)
                );
              }, this)
            ),
            _react2.default.createElement(
              'div',
              { className: 'center-align' },
              _react2.default.createElement(
                'h4',
                null,
                (0, _translate.t)('If you answered Yes to any of the questions you are not eligible to purchase coverage for pre-existing medical conditions.')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'center-align' },
              (0, _translate.t)('The  applicant  declares  that,  to  the  best  of  the  applicant’s  knowledge,  the  statements  and  answers  provided  are  truthful, complete and accurate. The applicant agrees that the statements and answers form part of the contract and that the insurance shall become effective in accordance with, and subject to, the terms and conditions of the policy. Misrepresentation or failure to disclose any material fact may void the policy at the option of the insurer.')
            ),
            _react2.default.createElement(
              'div',
              { className: 'buttons' },
              _react2.default.createElement(
                'button',
                { className: 'btn btn-primary button margin-left', onClick: this.hideMQModal },
                (0, _translate.t)('Save')
              )
            )
          )
        ) : null
      );
    }
  }]);

  return GetQuoteComponent;
}(_react2.default.Component);

GetQuoteComponent.propTypes = _extends({}, _reduxForm.propTypes, {
  params: _react2.default.PropTypes.object,
  auth: _react2.default.PropTypes.object,
  application: _react2.default.PropTypes.object,
  formConfig: _react2.default.PropTypes.object,
  savedQuote: _react2.default.PropTypes.object,
  trackingCode: _react2.default.PropTypes.string
});


var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.api.authorization,
    application: state.application,
    formConfig: state.formConfig.config,
    savedQuote: state.savedQuote.data
  };
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'genericis',
  fields: fields,
  destroyOnUnmount: false,
  touchOnBlur: false,
  validate: _Quote2.default
}, mapStateToProps)(GetQuoteComponent);


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/visitors/GetQuoteContainer.jsx
// module id = 207
// module chunks = 0